import React from 'react';
import ModalManager from './ModalManager';
import Modal from './Modal';
import useEventListener from '../reactUtils/useEventListener';
import { useTypedSelector } from '../../state/hooks';
import { CustomEventTypes } from '../../globals';

/**
 * responsible for displaying modal windows in the application
 * @export
 * @returns a container div where modals will be rendered, as well as the modals themselves
 */
export default function ModalRenderer()
{
	useEventListener(CustomEventTypes.onProjectLoadEnd, () => ModalManager.removeAllModals(), document);

	const modalWindowIds = useTypedSelector(state => state.workspaceModule.modals);

	return (
		<div className={"modalsRoot"}
			data-name={"modals-root"}
		>
			{
				Object.keys(modalWindowIds).map(modalId =>
				{
					const modalInfo = ModalManager.getModalInfo(modalId);
					if(!modalInfo) return null;
					
					if (modalInfo?.content?.type === Modal)
					{
						return (
							React.cloneElement(modalInfo.content, {
								key: modalId,
								id: modalId,
								contentRect: modalInfo.rect,
								showBackdrop: modalInfo.showBackdrop !== undefined ? modalInfo.showBackdrop : true,
								allowClickOut: modalInfo.allowClickOut !== undefined ? modalInfo.allowClickOut : true,
								clickThrough: modalInfo.clickThrough !== undefined ? modalInfo.clickThrough : false,
								clickThroughCover: modalInfo.clickThroughCover !== undefined ? modalInfo.clickThroughCover : false,
								onShutdown: function ()
								{
									if (modalInfo.content.props.onShutdown)
										modalInfo.content.props.onShutdown();

									ModalManager.removeModal(modalId);
									if(modalInfo.linkedModal?.onShutdown)
									{
										modalInfo.linkedModal.onShutdown();
									}
								},
								onModalCloseCallback: modalInfo?.content?.props?.onModalCloseCallback ?? undefined
							})
						)
					}
					else return (
						<Modal
							key={modalId}
							id={modalId}
							showBackdrop={modalInfo.showBackdrop !== undefined ? modalInfo.showBackdrop : true}
							allowClickOut={modalInfo.allowClickOut !== undefined ? modalInfo.allowClickOut : true}
							clickThrough={modalInfo.clickThrough !== undefined ? modalInfo.clickThrough : false}
							clickThroughCover={modalInfo.clickThroughCover !== undefined ? modalInfo.clickThroughCover : false}
							onShutdown={() => 
							{
								ModalManager.removeModal(modalId)
								if(modalInfo.linkedModal?.onShutdown)
								{
									modalInfo.linkedModal.onShutdown();
								}
							}}
							onModalCloseCallback ={modalInfo?.content?.props?.onModalCloseCallback}
							contentRect={modalInfo.rect}
						>
							{React.cloneElement(modalInfo.content, {
								id: modalId
							})}
						</Modal>
					);
				})
			}
		</div>
	);
}